import { useState, useEffect } from 'react';
import { isEqual } from 'lodash';

import { FormBase } from '../Interface';
import useUsers from '../../context/UsersContext';
import useMenus from '../../context/MenuContext';
import materialPlanService from '../../service/materialPlan.service';
import { MaterialPlanStatus } from '../../config/materialPlan';
import MaterialPlanForm from './MaterialPlanForm';
import MaterialPlanReports from './MaterialPlanReports';

export const defaultValues = {
  id: null,
  planNo: '',
  description: '',
  mode: null,
  dateFrom: null,
  dateTo: null,
  reference: '',
  status: MaterialPlanStatus.OPENED,
  itemFilter: null,
  materialPlanLine: [],
};

const MaterialPlanPage = () => {
  const { getUser, user } = useUsers();
  const { menus, getMenus, getMenuSubMenuId, getCanEdit } = useMenus();

  const [refetchTable, setRefetchTable] = useState(false);
  const [viewField, setViewField] = useState(true);
  const [selectedValues, setSelectedValues] = useState({});
  const [operatorsDisabled, setOperatorsDisabled] = useState(false);
  const [rowSelectionModel, setRowSelectionModel] = useState([]);
  const [canEdit, setCanEdit] = useState(true);

  useEffect(() => {
    getMenus();
    if (!Object.keys(user).length) getUser();
  }, []);

  useEffect(() => {
    if (!Object.keys(menus).length) return;
    const submenuId = getMenuSubMenuId('materialPlan');
    setCanEdit(getCanEdit(submenuId));
  }, [menus]);

  useEffect(() => {
    if (Object.keys(selectedValues).length > 0) {
      setOperatorsDisabled(isEqual(defaultValues, selectedValues));
    } else {
      setOperatorsDisabled(true);
    }
  }, [selectedValues]);

  const handlePlanSelect = (row) => {
    if (!row?.id) return;
    materialPlanService.getItem(row.id).then((data) => {
      setSelectedValues(data);
      setRowSelectionModel(row.id);
    });
  };

  return (
    <FormBase
      name="MaterialPlan"
      leftPanelContent={
        <MaterialPlanForm
          selectedValues={selectedValues}
          setSelectedValues={setSelectedValues}
          viewField={viewField}
          setViewField={setViewField}
          operatorsDisabled={operatorsDisabled}
          setOperatorsDisabled={setOperatorsDisabled}
          rowSelectionModel={rowSelectionModel}
          setRowSelectionModel={setRowSelectionModel}
          setRefetchTable={setRefetchTable}
          user={user}
          canEdit={canEdit}
        />
      }
      rightPanelContent={
        <MaterialPlanReports
          refetchTable={refetchTable}
          setRefetchTable={setRefetchTable}
          viewField={viewField}
          operatorsDisabled={operatorsDisabled}
          rowSelectionModel={rowSelectionModel}
          setRowSelectionModel={setRowSelectionModel}
          onRowClick={handlePlanSelect}
        />
      }
    />
  );
};

export default MaterialPlanPage;
